import {
  SET_ENGINE_ROW,
  SET_LINE_LIST,
  SET_ROW_ENGINE_ID,
} from './mutation-types'
import api from '@/api'
const state = {
  form: {},
  list: [],
  engineId: '',
}

const mutations = {
  [SET_ENGINE_ROW] (state, payload) {
    state.form = payload
  },
  [SET_LINE_LIST] (state, payload) {
    state.list = payload
  },
  [SET_ROW_ENGINE_ID] (state, payload) {
    state.engineId = payload
  },
}

const actions = {
  // 引擎--查询引擎列表
  async queryEngines () {
    let data = await api.transmissionApi.queryEngines({})
    return data
  },
  // 引擎--新增引擎
  async addTaskEngine ({dispatch}, payload) {
    let data = await api.transmissionApi.addTaskEngine(payload)
    return data
  },
  // 引擎--修改引擎
  async updateTaskEngine ({dispatch}, payload) {
    let data = await api.transmissionApi.updateTaskEngine(payload)
    return data
  },
  async setEngineRow ({commit}, payload) {
    commit(SET_ENGINE_ROW, payload)
  },
  // 删除引擎
  async deleteEngine ({dispatch}, payload) {
    let data = await api.transmissionApi.deleteEngine(payload)
    return data
  },
  async addOrUpdateTaskEngineLine ({state, dispatch}, payload) {
    let data = await api.transmissionApi.addOrUpdateTaskEngineLine(payload)
    // dispatch('queryEngineLineInfo', {engineId: state.engineId})
    return data
  },
  async queryEngineLineInfo ({commit}, payload) {
    let data = await api.transmissionApi.queryEngineLineInfo(payload)
    if (data.data) commit(SET_LINE_LIST, data.data)
    return data
  },
  setRowEngineId ({commit}, payload) {
    commit(SET_ROW_ENGINE_ID, payload)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
